import { render, staticRenderFns } from "./roles.vue?vue&type=template&id=7e69018c&scoped=true&"
import script from "./roles.vue?vue&type=script&lang=js&"
export * from "./roles.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e69018c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/brisk/brisk-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7e69018c')) {
      api.createRecord('7e69018c', component.options)
    } else {
      api.reload('7e69018c', component.options)
    }
    module.hot.accept("./roles.vue?vue&type=template&id=7e69018c&scoped=true&", function () {
      api.rerender('7e69018c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/users/actions/roles.vue"
export default component.exports